import AntdAvatar from 'components/Avatar'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import { StyledDivider } from 'components/UIComponents/FormStyles'
import LeftMarkIcon from 'components/icons/LeftMarkIcon'
import RightArrowIcon from 'components/icons/RightArrowIcon'
import React, { useRef, useState } from 'react'

import { AntdSpan } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import ScheduleClock from '../../../../../../components/icons/ScheduleClock'
import {
  AdjustIcon,
  BreakDiv,
  CardText,
  CaroselDiv,
  CarouselFlex,
  FooterFlex,
  GroupIdDiv,
  HeaderFlex,
  IntervierFlex,
  OutlineDiv,
  RightArrowDiv,
  Sliders,
  StyledFlex,
  TagWarapper,
} from './style'

const CreateSlot = ({
  setCreateSlotDrawer,
  confirmedResponse,
  createSloScheduletDrawer,
  setCreateSloScheduletDrawer,
  setPrivew,
}) => {
  const [slide, setSlide] = useState(0)
  const handleConfirm = () => {
    setPrivew(true)
  }

  const handleGoBack = () => {
    setCreateSloScheduletDrawer(false)
    setCreateSlotDrawer(true)
  }

  const slider = useRef()

  const content = () => {
    return (
      <>
        <HeaderFlex row centerVertically>
          <AdjustIcon
            onClick={() => {
              slider.current.prev()
            }}
          >
            <LeftMarkIcon />
          </AdjustIcon>
          <CaroselDiv>
            <Sliders
              dots={false}
              ref={ref => {
                slider.current = ref
              }}
              beforeChange={() => setSlide(true)}
              afterChange={data => {
                setSlide(false)
              }}
            >
              {confirmedResponse?.linkAndPanel?.map((panel, index) => {
                return (
                  <div key={index + 'panelItem'}>
                    <CarouselFlex row>
                      <IntervierFlex centerVertically value={slide}>
                        Panel{index + 1}-&nbsp;
                        {panel?.panel?.slice(0, 1)?.map((item, kIndex) => {
                          return (
                            <TagWarapper key={kIndex + item?.firstName}>
                              {item?.firstName + ' ' + item?.lastName}
                            </TagWarapper>
                          )
                        })}
                        {!!(panel?.panel?.length - 1) && (
                          <TagWarapper>+{panel?.panel?.length - 1}</TagWarapper>
                        )}
                      </IntervierFlex>
                      {confirmedResponse?.linkAndPanel[index + 1] && (
                        <IntervierFlex centerVertically value={slide}>
                          Panel{index + 2}-&nbsp;
                          {confirmedResponse?.linkAndPanel[index + 1]?.panel
                            ?.slice(0, 1)
                            ?.map((item, index) => {
                              return (
                                <TagWarapper key={index + item?.firstName}>
                                  {item?.firstName + ' ' + item?.lastName}
                                </TagWarapper>
                              )
                            })}
                          {!!(panel?.panel?.length - 1) && (
                            <TagWarapper>
                              +{panel?.panel?.length - 1}
                            </TagWarapper>
                          )}
                        </IntervierFlex>
                      )}
                    </CarouselFlex>
                  </div>
                )
              })}
            </Sliders>
          </CaroselDiv>
          <RightArrowDiv
            onClick={() => {
              slider.current.next()
            }}
          >
            <RightArrowIcon />
          </RightArrowDiv>
        </HeaderFlex>
        <div></div>
        <StyledDivider />
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <CardText>12:00 PM</CardText>
          <StyledFlex>
            <OutlineDiv>
              <GroupIdDiv>Group ID - GD001</GroupIdDiv>
              <CardText>12:00 PM - 12:15 PM</CardText>
              <AntdSpan>
                <AntdAvatar size="50" IconName={'kldklsdk'} src={'ohsfldl'} />
              </AntdSpan>
            </OutlineDiv>
          </StyledFlex>
        </div>
        <BreakDiv>
          <ScheduleClock />
          <GroupIdDiv> Break 2 - 01:00 pm - 01:30 pm</GroupIdDiv>
        </BreakDiv>
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="88px"
          height="38px"
          text="Back"
          onClick={handleGoBack}
        />
        <Button.Primary
          width="95px"
          height="38px"
          text="Proceed"
          onClick={handleConfirm}
        />
      </FooterFlex>
    )
  }

  return (
    <Drawer
      width="43%"
      title={'Schedule - Preview'}
      placement="right"
      visible={createSloScheduletDrawer}
      content={content()}
      footer={footer()}
      onClose={() => {
        setCreateSloScheduletDrawer(false)
      }}
      closable
    />
  )
}

export default CreateSlot
